import * as React from "react";
import { selectResourceAmountInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { Badge } from "../../generic/badge/Badge";
import { ButtonInfoSmall } from "../../generic/common/ButtonInfoSmall";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
import { getStaticStarsAnimation } from "./CrystalBallAnimation";
export var FortuneTellerEventReward = function (_a) {
    var fortuneTellerEventPackageDetails = _a.fortuneTellerEventPackageDetails, onShowAllRewards = _a.onShowAllRewards;
    if (fortuneTellerEventPackageDetails == undefined) {
        return (React.createElement("div", { className: "crystal-ball-animation" },
            React.createElement("div", { className: "stars-container" },
                " ",
                getStaticStarsAnimation())));
    }
    var _b = fortuneTellerEventPackageDetails.bestRandomReward, resourceId = _b.resourceId, amount = _b.amount;
    var bestRewardResource = selectResourceAmountInfo(resourceId, amount);
    return (React.createElement("div", { className: IdStyles.FortuneTellerRewardBackground + " pos-rel flex flex--guts flex--stacked" },
        React.createElement(TextLoca, { id: IdLoca.fortuneTellerBestReward_desc, className: IdStyles.TextBoldPrimary }),
        React.createElement("div", { className: IdStyles.TraderEventRewardImageBackground + " mt__large flex flex--stacked flex--guts" },
            React.createElement(ResourceIcon, { resource: bestRewardResource, styleId: IdStyles.IconExtraLarge, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
            React.createElement(NumberFormat, { className: IdStyles.TextBoldPrimary, amount: bestRewardResource.amount })),
        React.createElement(Badge, null,
            React.createElement(ButtonInfoSmall, { onClick: onShowAllRewards },
                React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/FortuneTellerEventReward.tsx
// module id = 2839
// module chunks = 3